// @ts-nocheck
import { Plugin } from '/Users/jiangyichen/Desktop/work/FE-src/third-link/node_modules/_@umijs_runtime@3.5.43@@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','request',],
});

export { plugin };
